<template>
  <div class="col-sm-6" style="padding-right: 0;">
    <b-form-checkbox
      v-bind:id="filter.id"
      v-model="filter.value"
      value="1"
      unchecked-value
      v-on:input="emitToggleEvent()"
    />
  </div>
</template>

<script>
export default {
  name: 'CheckBoxFilter',
  props: ['filter'],
  data: function() {
    return {
      data: ''
    };
  },
  beforeMount() {},
  methods: {
    emitToggleEvent() {
      this.$emit('toggle-value');
    }
  }
};
</script>

<style scoped>
.custom-control {
  min-height: 28px;
}
</style>
